export default __webpack_public_path__ + "static/media/murales.593b1199.jpg";